// コントローラーの状態を管理するslice
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// 初期値
const initialState = {
  isControllerSticky: true,
  isChangeDashboardPlanProcMach: true,
}

export const controllerStateSlice = createSlice({
  name: 'controllerStateSlice',
  initialState, 
  reducers: {
    // 加工実績画面のコントローラのsticky制御
    setIsControllerSticky: (state, action: PayloadAction<boolean>) => {
      state.isControllerSticky = action.payload;
    },
    // 加工実績画面の工場・加工・機械の変更フラグ
    setIsChangeDashboardPlanProcMach: (state, action: PayloadAction<boolean>) => {
        state.isChangeDashboardPlanProcMach = action.payload;
    },
  },
});

const {setIsControllerSticky} = controllerStateSlice.actions;
const {setIsChangeDashboardPlanProcMach} = controllerStateSlice.actions;

export {setIsControllerSticky, setIsChangeDashboardPlanProcMach}
export default controllerStateSlice.reducer;
